import React from "react";
import {
  Grid,
  TextField,
  Switch,
  FormControlLabel,
  Typography,
  Box,
  useTheme,
} from "@mui/material";

interface Props {
  config: any;
  onChange: (field: string, value: any) => void;
}

const OctaneForm: React.FC<Props> = ({ config, onChange }) => {
  const theme = useTheme();
  const red = "#C62828"; // UMS red accent

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.background.paper,
        borderLeft: `3px solid ${red}`,
        borderRadius: 2,
        p: 2,
        mt: 1,
        boxShadow: "0 0 6px rgba(0,0,0,0.3)",
      }}
    >
      <Typography
        variant="subtitle1"
        sx={{
          mb: 2,
          fontWeight: 600,
          color: red,
          letterSpacing: 0.3,
        }}
      >
        Octane FTP Configuration
      </Typography>

      <Grid container spacing={2}>
        {/* Enabled Switch */}
        <Grid item xs={6}>
          <FormControlLabel
            control={
              <Switch
                checked={config.enabled ?? false}
                onChange={(e) => onChange("enabled", e.target.checked)}
                sx={{
                  "& .MuiSwitch-switchBase.Mui-checked": { color: red },
                  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                    backgroundColor: red,
                  },
                }}
              />
            }
            label={<Typography sx={{ fontWeight: 500 }}>Enabled</Typography>}
          />
        </Grid>

        {/* Syndication Image Group */}
        <Grid item xs={6}>
          <TextField
            label="Syndication Image Group"
            fullWidth
            value={config.syndicationImageGroup || ""}
            onChange={(e) => onChange("syndicationImageGroup", e.target.value)}
            variant="outlined"
            InputLabelProps={{ style: { color: "#aaa" } }}
            sx={{
              "& .MuiOutlinedInput-root": {
                "& fieldset": { borderColor: "#444" },
                "&:hover fieldset": { borderColor: red },
                "&.Mui-focused fieldset": { borderColor: red },
              },
              "& .MuiInputBase-input": { color: "#fff" },
            }}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default OctaneForm;
